<template>
  <icon-badge
    :class="['bg-' + systemState, 'border-' + systemState, 'text-' + systemState]"
    :icon-class="{
      'fas fa-check': systemState == 'approved',
      'fas fa-question': systemState == 'maybe',
      'fas fa-times': systemState == 'rejected',
    }"
  >
    {{ state }}
  </icon-badge>
</template>

<script>
export default {
  props: {
    systemState: {
      type: String,
      required: true,
    },
    state: {
      type: String,
      required: true,
    },
  },
}
</script>
